import whichEnv from '@ally/which-env';
var env = whichEnv();
/**
 * The Ally Next CDN URL for the loaded environment.
 *
 * This includes `https://` and does **not** include a trailing slash.
 *
 * @example
 * import { CDN_URL } from '@ally-financial/next-core'
 * // ...
 * fetch(`${CDN_URL}/assets/json/invalid-strings.json`)
 *  .then(...)
 *  .catch(...)
 */
export var CDN_URL = env.pick({
    local: 'https://ally-next-cdn-dev.5ne0rmk6q065.services.ally.com',
    dev: 'https://ally-next-cdn-dev.5ne0rmk6q065.services.ally.com',
    qa1: 'https://ally-next-cdn-qa.hgiebqv1vafp.services.ally.com',
    qa2: 'https://ally-next-cdn-qa.hgiebqv1vafp.services.ally.com',
    qa3: 'https://ally-next-cdn-qa.hgiebqv1vafp.services.ally.com',
    cap: 'https://ally-next-cdn-qa.hgiebqv1vafp.services.ally.com',
    fix: 'https://ally-next-cdn-psp.ew3iq9d5h966.services.ally.com',
    psp: 'https://ally-next-cdn-psp.ew3iq9d5h966.services.ally.com',
    prod: 'https://ally-next-cdn.ew3iq9d5h966.services.ally.com',
});
//# sourceMappingURL=constants.js.map